"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CashRegister = function CashRegister(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    d: "M18.25 18.875H5.75a.625.625 0 01-.625-.625v-1.875c0-.345.28-.625.625-.625h12.5c.345 0 .625.28.625.625v1.875c0 .345-.28.625-.625.625zM12.937 17h-1.874a.312.312 0 100 .625h1.874a.312.312 0 100-.625zm5.313-1.875H5.75a.625.625 0 01-.625-.625v-.778c0-.21.052-.415.153-.599l1.57-2.877c.1-.184.152-.39.152-.6V8.25C7 7.56 7.56 7 8.25 7h4.375V5.75h-1.406a.469.469 0 01-.469-.469v-.937c0-.26.21-.469.469-.469h4.062c.26 0 .469.21.469.469v.937c0 .26-.21.469-.469.469h-1.406V7h1.875c.69 0 1.25.56 1.25 1.25v1.397c0 .209.052.415.153.598l1.57 2.878c.1.184.152.39.152.599v.778c0 .345-.28.625-.625.625zm-2.5-6.563a.312.312 0 00-.313-.312h-4.374a.312.312 0 00-.313.313v.624c0 .173.14.313.313.313h4.374c.173 0 .313-.14.313-.313v-.624z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(CashRegister);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CashRegister, "CashRegister", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/CashRegister.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/CashRegister.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9DYXNoUmVnaXN0ZXIudHN4Il0sIm5hbWVzIjpbIkNhc2hSZWdpc3RlciIsInByb3BzIiwicmVmIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxZQUE0RSxHQUFHLFNBQS9FQSxZQUErRSxDQUFDQyxLQUFELEVBQVFDLEdBQVI7QUFBQSxTQUNuRjtBQUFLLElBQUEsS0FBSyxFQUFFLEVBQVo7QUFBZ0IsSUFBQSxNQUFNLEVBQUUsRUFBeEI7QUFBNEIsSUFBQSxPQUFPLEVBQUM7QUFBcEMsS0FBb0RELEtBQXBEO0FBQTJELElBQUEsR0FBRyxFQUFFQztBQUFoRSxNQUNFO0FBQ0UsSUFBQSxDQUFDLEVBQUMsNnNCQURKO0FBRUUsSUFBQSxJQUFJLEVBQUM7QUFGUCxJQURGLENBRG1GO0FBQUEsQ0FBckY7O2VBU2UsdUJBQVdGLFlBQVgsQzs7Ozs7Ozs7Ozs7OzswQkFUVEEsWSIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBmb3J3YXJkUmVmLCBSZWZGb3J3YXJkaW5nQ29tcG9uZW50LCBTVkdQcm9wcyB9IGZyb20gJ3JlYWN0JztcblxuY29uc3QgQ2FzaFJlZ2lzdGVyOiBSZWZGb3J3YXJkaW5nQ29tcG9uZW50PFNWR1NWR0VsZW1lbnQsIFNWR1Byb3BzPFNWR1NWR0VsZW1lbnQ+PiA9IChwcm9wcywgcmVmKSA9PiAoXG4gIDxzdmcgd2lkdGg9ezI0fSBoZWlnaHQ9ezI0fSB2aWV3Qm94PVwiMCAwIDI0IDI0XCIgey4uLnByb3BzfSByZWY9e3JlZn0+XG4gICAgPHBhdGhcbiAgICAgIGQ9XCJNMTguMjUgMTguODc1SDUuNzVhLjYyNS42MjUgMCAwMS0uNjI1LS42MjV2LTEuODc1YzAtLjM0NS4yOC0uNjI1LjYyNS0uNjI1aDEyLjVjLjM0NSAwIC42MjUuMjguNjI1LjYyNXYxLjg3NWMwIC4zNDUtLjI4LjYyNS0uNjI1LjYyNXpNMTIuOTM3IDE3aC0xLjg3NGEuMzEyLjMxMiAwIDEwMCAuNjI1aDEuODc0YS4zMTIuMzEyIDAgMTAwLS42MjV6bTUuMzEzLTEuODc1SDUuNzVhLjYyNS42MjUgMCAwMS0uNjI1LS42MjV2LS43NzhjMC0uMjEuMDUyLS40MTUuMTUzLS41OTlsMS41Ny0yLjg3N2MuMS0uMTg0LjE1Mi0uMzkuMTUyLS42VjguMjVDNyA3LjU2IDcuNTYgNyA4LjI1IDdoNC4zNzVWNS43NWgtMS40MDZhLjQ2OS40NjkgMCAwMS0uNDY5LS40Njl2LS45MzdjMC0uMjYuMjEtLjQ2OS40NjktLjQ2OWg0LjA2MmMuMjYgMCAuNDY5LjIxLjQ2OS40Njl2LjkzN2MwIC4yNi0uMjEuNDY5LS40NjkuNDY5aC0xLjQwNlY3aDEuODc1Yy42OSAwIDEuMjUuNTYgMS4yNSAxLjI1djEuMzk3YzAgLjIwOS4wNTIuNDE1LjE1My41OThsMS41NyAyLjg3OGMuMS4xODQuMTUyLjM5LjE1Mi41OTl2Ljc3OGMwIC4zNDUtLjI4LjYyNS0uNjI1LjYyNXptLTIuNS02LjU2M2EuMzEyLjMxMiAwIDAwLS4zMTMtLjMxMmgtNC4zNzRhLjMxMi4zMTIgMCAwMC0uMzEzLjMxM3YuNjI0YzAgLjE3My4xNC4zMTMuMzEzLjMxM2g0LjM3NGMuMTczIDAgLjMxMy0uMTQuMzEzLS4zMTN2LS42MjR6XCJcbiAgICAgIGZpbGw9XCJjdXJyZW50Q29sb3JcIlxuICAgIC8+XG4gIDwvc3ZnPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgZm9yd2FyZFJlZihDYXNoUmVnaXN0ZXIpO1xuIl19